import { MutableRefObject, useEffect, useState } from "react";

type SectionRef = { e: HTMLElement | null; offset: number };

const useIntersection = (
  refs: MutableRefObject<SectionRef[]>,
  threshold: number = 0.75,
  /** Live sticky-stack offset (site header + compact title + tabs). */
  spyOffsetRef?: MutableRefObject<number>
) => {
  const [visibleTarget, setVisibleTarget] = useState("");

  useEffect(() => {
    const onScroll = () => {
      let nextVisible = "";

      for (const item of refs.current) {
        if (!item?.e) continue;
        const { top } = item.e.getBoundingClientRect();
        const offset =
          spyOffsetRef && spyOffsetRef.current > 0
            ? spyOffsetRef.current
            : item.offset;

        // Last section whose top has reached/passed the sticky line wins.
        if (top <= offset + threshold) {
          nextVisible = item.e.id;
        }
      }

      if (nextVisible) {
        setVisibleTarget((prev) => (prev === nextVisible ? prev : nextVisible));
      }
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [refs, threshold, spyOffsetRef]);

  return { visibleTarget };
};

export default useIntersection;
